/**
 * /devhub/agents — Agents (operator). Surface Layer (/01). REQ-001.91 DevHub UI rebuild · Phase 3.
 * Live operator panel (DevHubAgentRegistryPanel) wired to its useDevHub* hook over GET /api/control/registry/:name.
 * Operator-only (routePolicy plane guard + DevHubPanelPage self-guard).
 */
import { createFileRoute } from '@tanstack/react-router';
import { DevHubAgentRegistryPanel } from '../features/control-plane/DevHubAgentRegistryPanel';
import { DevHubPanelPage } from '../components/devhub/DevHubPanelPage';

export const Route = createFileRoute('/devhub/agents')({ component: AgentsPage });

function AgentsPage() {
  return (
    <DevHubPanelPage
      title="Agents"
      subtitle="Agent registry — roles, planes and grounding policy."
      status={{ label: 'live', live: true }}
    >
      <DevHubAgentRegistryPanel />
    </DevHubPanelPage>
  );
}
